module.exports = __webpack_public_path__ + "static/media/nashville-hot-chicken-sandwich-mobile-fr.b9dd80fd.jpg";